import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { take } from 'rxjs';
import { UserService } from '../../core/user.service';
import { SharedModule } from '../../shared/shared.module';
import { generateUUID } from '../../utils/common-methods';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [SharedModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  loginForm: any;

  constructor(public auth: AuthService, private router: Router, private fb: FormBuilder,
              public userService: UserService) {
    this.loginForm = this.fb.group({
      companyName: ['', Validators.required],
    });
  }

  onLogin(): void {
    const companyName = this.loginForm.value.companyName.trim().toLowerCase();
    localStorage.setItem('companyName', companyName);
    let uuid = localStorage.getItem("uuid") ?? "";
    if(!uuid) {
      uuid = generateUUID();
      localStorage.setItem("uuid", uuid);
    }
    this.userService.validateCompany(companyName)
      .pipe(take(1))
      .subscribe((result: boolean) => {
      if (result) {
        this.auth.loginWithRedirect().subscribe(() => {
          this.router.navigate(['/dashboard']);
        });
      }
    });
  }
}
